export const tags = [
  "jnct-assessment-editor",
  "jnct-editor-filters",
  "jnct-editor-list",
  "jnct-editor-item",
  "jnct-add-existing-item-modal",
  "jnct-item-authoring-modal",
  "jnct-add-from-qti-modal",
  "jnct-assessment-editor-filters-settings",
  "jnct-editor-add-lo-modal",
  "jnct-editor-warning-modal",
  "jnct-regrade-item-modal",
] as const;
